import Axios from "./index";

export const createPrompt = (promptParams) => {
  return Axios.post(`/user/prompts`, { prompt: promptParams });
};
